import styles from './styles.module.css'
import { useMemo } from 'react'
import { useTranslation } from 'next-i18next'
import { useSelector } from 'react-redux'
import InfoCardWithTwoButtons from '@/components/entity/draw/cards/info-cards/with-two-buttons'
import { BUTTON_SIZES, BUTTON_TYPES } from '@/components/ui/button'
import InfoCardWithLocuses from '@/components/entity/draw/cards/info-cards/with-locuses'
import InfocenterVideo from '@/components/entity/draw/sidebar/infocenter/video'
import { getLocusWithRegistrationBonus } from '@utils/locus'

const DrawCardsMobile = () => {
  const { t } = useTranslation('draw')
  const { user } = useSelector(({ user }) => user)
  const { rafflesVideos } = useSelector(({ draw }) => draw)
  const pointsData = useMemo(() => {
    return getLocusWithRegistrationBonus(user.balance)
  }, [user.balance])
  const data = { gold: pointsData?.goldPoints || 0, silver: pointsData?.silverPoints || 0 }

  const card = useMemo(() => {
    return {
      label: t('draw::cards::tasks', { count: Number(user?.tasksUncompleted) || 0 }),
      count: user?.tasksUncompleted || 0,
      buttons: [
        {
          text: t('draw::cards::earnLocus'),
          link: '/draw/tasks',
          size: BUTTON_SIZES.DEFAULT,
          type: BUTTON_TYPES.BLUE,
          value: 'tasks',
        },
        {
          text: t('draw::cards::learnMore'),
          link: '/blog',
          size: BUTTON_SIZES.DEFAULT,
          type: BUTTON_TYPES.YELLOW,
          value: 'blog',
        },
      ],
    }
  }, [t, user])

  return (
    <div className={styles.cardsColumn}>
      {/*TODO add if you need tasks card*/}
      {/*<InfoCardWithTwoButtons card={card} />*/}
      <InfoCardWithLocuses {...data} />
      <InfocenterVideo videos={rafflesVideos} />
    </div>
  )
}

export default DrawCardsMobile
